export default {
    url: '/general',
    template: `
        <courses-courses-edit-version-edit-general
            course="vm.course"
            course-version="vm.courseVersion"
            can-manage-course="vm.canManageCourse"
        />`,
    controller ($scope, course, CourseService) {
        this.courseVersion = $scope.$parent.vm.courseVersion;
        this.course = course;
        this.canManageCourse = CourseService.canManageCourse(course);
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/edit/version/edit/general/index.js